var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinDotSlashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0438 6.16183C15.0244 6.25863 14.9769 6.34753 14.9071 6.41733L12.982 8.34239C12.8011 8.52334 12.69 8.77395 12.69 9.04999C12.69 9.60227 13.1377 10.05 13.69 10.05C13.9821 10.05 14.245 9.92472 14.4278 9.72497L16.3213 7.83154C16.6703 7.48254 16.9082 7.03804 17.005 6.55407L17.0798 6.17999L21.8619 10.9621L21.4878 11.0369C21.0039 11.1337 20.5594 11.3716 20.2104 11.7206L18.3463 13.5847C18.1284 13.7681 17.99 14.0429 17.99 14.35C17.99 14.9023 18.4377 15.35 18.99 15.35C19.2672 15.35 19.5181 15.2372 19.6993 15.0549L19.7019 15.0575L21.6246 13.1348C21.6944 13.065 21.7833 13.0175 21.8801 12.9981L24.0864 12.5568C24.8696 12.4002 25.1621 11.4339 24.5974 10.8692L17.1727 3.44454C16.608 2.87977 15.6417 3.17234 15.4851 3.95553L15.0438 6.16183Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7C11.3284 7 12 6.32843 12 5.5C12 4.67157 11.3284 4 10.5 4C9.67157 4 9 4.67157 9 5.5C9 6.32843 9.67157 7 10.5 7Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 5.29289C4.68342 4.90237 5.31658 4.90237 5.70711 5.29289L22.7068 22.2926C23.0974 22.6832 23.0974 23.3163 22.7068 23.7068C22.3163 24.0974 21.6832 24.0974 21.2926 23.7068L17.7086 20.1228L17.5252 22.5073C17.467 23.2644 16.806 23.831 16.0488 23.7728C15.7215 23.7476 15.4141 23.6062 15.182 23.3741L10.632 18.8241L4.97514 24.481C4.03233 25.4238 2.61811 24.0096 3.56092 23.0667L9.21778 17.4099L4.66778 12.8599C4.13081 12.3229 4.13081 11.4523 4.66778 10.9153C4.89987 10.6833 5.20733 10.5418 5.53459 10.5167L7.91904 10.3333L4.29289 6.70711C3.90237 6.31658 3.90237 5.68342 4.29289 5.29289ZM9.78167 12.1959L7.04287 12.4066L15.6353 20.999L15.846 18.2602L9.78167 12.1959Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDotSlashOutline);
export default __webpack_public_path__ + "static/media/pin_dot_slash_outline.08a00df095bf285a69a64dd299903673.svg";
export { ForwardRef as ReactComponent };